import Dashboard from "./Dashboard";
import Profile from "./Profile";
import SiteRequestForm from "./SiteRequestForm";
import MySitesDashboard from "./MySitesDashboard";
import ManageShops from "./ManageShops";
import EditShopPages from "./manageShop/EditShopPages";
import EditShopInfo from "./manageShop/EditShopInfo";
import EditShopProducts from "./manageShop/EditShopProducts";
import AddShopProductPage from "./AddShopProductPage";
import EditShopProductPage from "./EditShopProductPage";
import EditShopCategories from "./manageShop/EditShopCategories";
import EditShopShowcase from "./manageShop/EditShopShowcase";
import ShopTrustSeal from "./manageShop/ShopTrustSeal";

import ShopCardInfo from "./manageShop/ShopCardInfo";

import ManageOrders from "./ManageOrders";
import OrderDetails from "./OrderDetails";
import Customers from "./Customers";
import Commission from "./Commission";
import Wallet from "./Wallet";
import WithdrawRequests from "./WithdrawRequests";
import Transactions from "./Transactions";
import NewTicket from "./NewTicket";
import TicketArchive from "./TicketArchive";
import TicketDetail from "./TicketDetail";
import RegisterSiteForm from "./RegisterSiteForm";
import ChatArchive from "./ChatArchive";
import ChatPage from "./ChatPage";
import ManageShopDetail from "./ManageShopDetail";
import PanelUserProMajazi from "../../proMajazi/user/panelUserProMajazi";

// نکته: children اینجا به‌صورت مسیر «مستقل ولی هم‌سطح» ساخته میشن
// (یعنی /panel/manage-shops/:shopId/pages یه Route جداگانه‌ست، نه چیزی
// که داخل <Outlet /> کامپوننت ManageShops رندر بشه). به همین خاطر لازم
// نیست ManageShops.jsx خودش Outlet داشته باشه — وقتی کاربر وارد یکی
// از این مسیرها بشه، کلاً به‌جای ManageShops همون کامپوننت فرزند رندر میشه.
//
// برای صفحه‌ای که child نداره، فقط id و Component رو بنویس.
export const PAGE_ROUTES = [
  { id: "dashboard", Component: Dashboard },
  { id: "profile", Component: Profile },
  { id: "sites-requests", Component: SiteRequestForm },
  { id: "my-sites", Component: MySitesDashboard },
  {
    id: "manage-shops",
    Component: ManageShops,
    children: [
      { path: ":shopId", Component: ManageShopDetail },
      { path: ":shopId/pages", Component: EditShopPages },
      { path: ":shopId/info", Component: EditShopInfo },
      { path: ":shopId/products", Component: EditShopProducts },
      { path: ":shopId/products/add", Component: AddShopProductPage },
      {
        path: ":shopId/products/edit/:productId",
        Component: EditShopProductPage,
      },
      { path: ":shopId/category", Component: EditShopCategories },
      { path: ":shopId/showcase", Component: EditShopShowcase },
      { path: ":shopId/card", Component: ShopCardInfo },
      { path: ":shopId/trust", Component: ShopTrustSeal },
    ],
  },

  {
    id: "manage-orders",
    Component: ManageOrders,
    children: [{ path: ":orderId", Component: OrderDetails }],
  },

  { id: "customers", Component: Customers },
  { id: "commission", Component: Commission },
  { id: "wallet", Component: Wallet },
  { id: "withdraw-requests", Component: WithdrawRequests },
  { id: "transactions", Component: Transactions },
  { id: "new-ticket", Component: NewTicket },
  {
    id: "ticket-archive",
    Component: TicketArchive,
    children: [{ path: ":ticketId", Component: TicketDetail }],
  },
  {
    id: "chat-archive",
    Component: ChatArchive,
    children: [{ path: ":chatId", Component: ChatPage }],
  },

  { id: "register-site", Component: RegisterSiteForm },
];

// برای سازگاری با کدهای قدیمی که هنوز از PAGE_COMPONENTS استفاده می‌کنن
// (مثلاً اگه جای دیگه‌ای از پروژه بهش رفرنس داده شده)
export const PAGE_COMPONENTS = Object.fromEntries(
  PAGE_ROUTES.map(({ id, Component }) => [id, Component]),
);
